<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <div class="flex flex-col gap-1 text-sm">
      <span class="text-gray-700">
        The AI applies the AI rules in effect for this program to each configuration. AI findings are questions for
        you to decide, not errors. Accept a finding when it is intended, or Dismiss it when the AI is wrong; a Block
        finding needs a reason. A Warn finding never stops activation. To fix one, change the configuration and run the
        check again.
      </span>
      <span class="font-semibold">{{ runText() }}
        @if (review) {
          {{ openCount() === 0 ? 'No open blocking findings.' : openCount() + ' open blocking finding(s).' }}
          {{ warningCount() === 0 ? '' : warningCount() + ' open warning(s).' }}
        }
      </span>
    </div>
    @if (!isReadOnly()) {
      <div class="ml-auto flex items-center gap-2">
        <prox-ai-button label="Run AI Program Check" [loading]="isRunning"
          tooltip="The AI checks each configuration. About a minute for every four configurations."
          (clicked)="onRunCheck()"></prox-ai-button>
      </div>
    }
  </div>

  @if (runError) {
    <div class="mb-2 rounded border border-red-300 bg-red-50 p-3 text-sm text-red-700">
      <div class="font-semibold">The AI Program Check did not run</div>
      <div>{{ runError }}</div>
    </div>
  }

  @if (isRunning) {
    <div class="flex flex-1 flex-col items-center justify-center gap-4">
      <p-progressSpinner styleClass="h-16 w-16" strokeWidth="4" animationDuration="1s" ariaLabel="The AI is checking the program" />
      <div class="text-base font-semibold">The AI is checking {{ program.name }}</div>
      <div class="text-sm text-gray-600">About a minute for every four configurations. {{ runElapsed }} seconds so far.</div>
    </div>
  } @else {
    <div class="qb-layout-grid">
      <prox-ag-grid [gridOptions]="gridOptions" [rowData]="findings"></prox-ag-grid>
    </div>
  }
</ng-template>

<!-- EXCEPTION to Template 1's default Go Back footer: findings are resolved in place, so the page
     needs Save and Cancel, the same as the AI Guidelines pages. -->
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" [isReadOnly]="isReadOnly()" (undo)="onUndo()" (save)="onSave()"
    (cancel)="onCancel()"></prox-save-cancel>
</ng-template>
